import {
  Droplet,
  Flame,
  Hammer,
  Home,
  Plug,
  Settings,
  Snowflake,
  Thermometer,
  Wind,
  Wrench,
  Zap,
  type LucideIcon,
} from 'lucide-react';

/**
 * The single registry of job-type icons: the Appearance picker offers exactly
 * these names, and every surface that paints a job type resolves through here.
 * The list used to be duplicated (picker vs dispatch chip), which is how the
 * settings list ended up ignoring the stored icon entirely.
 *
 * The name string is what the backend stores on JobType.icon.
 */
export const JOB_TYPE_ICON_OPTIONS: readonly { name: string; Icon: LucideIcon }[] = [
  { name: 'Wrench', Icon: Wrench },
  { name: 'Zap', Icon: Zap },
  { name: 'Droplet', Icon: Droplet },
  { name: 'Flame', Icon: Flame },
  { name: 'Snowflake', Icon: Snowflake },
  { name: 'Wind', Icon: Wind },
  { name: 'Thermometer', Icon: Thermometer },
  { name: 'Plug', Icon: Plug },
  { name: 'Hammer', Icon: Hammer },
  { name: 'Home', Icon: Home },
  { name: 'Settings', Icon: Settings },
] as const;

export const DEFAULT_JOB_TYPE_ICON_NAME = 'Wrench';

/** The stored icon, or undefined when unset / no longer offered. */
export function findJobTypeIcon(icon?: string | null): LucideIcon | undefined {
  if (!icon) return undefined;
  return JOB_TYPE_ICON_OPTIONS.find((option) => option.name === icon)?.Icon;
}

/** The stored icon, falling back to the wrench for unset / retired names. */
export function resolveJobTypeIcon(icon?: string | null): LucideIcon {
  return findJobTypeIcon(icon) ?? Wrench;
}
